<template>
  <div class="counter fontWeightBlack fontNoSoBlack">
    <p class="counterTitle has-text-dark">Clientes satisfechos</p>
    <ICountUp
      class="has-text-dark   mobileFontCounter"
      :delay="delay"
      :endVal="endVal"
      :options="options"
      @ready="onReady"
    />
  </div>
</template>

<script type="text/babel">
  import ICountUp from 'vue-countup-v2';
  export default {
    name: 'demo',
    components: {
      ICountUp
    },
    data() {
      return {
        delay: 500,
        endVal: 887,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: '',
          duration: 4
        },
        
      };
    },
    methods: {
      onReady: function(instance, CountUp) {
        const that = this;
        instance.update(that.endVal + 2019);
        console.log(CountUp)
      }
    }
  };
</script>
